<router-outlet></router-outlet>
<app-fs-toast />
<p-dialog [(visible)]="showCustomerWarning" [modal]="true" [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
    [style]="{ width: '50vw' }" [resizable]="false" [closable]="false" [draggable]="false">
    <ng-template pTemplate="header">
        <div class="flex-grow-1 flex align-items-center justify-content-start gap-2 custom-dialog">
            <span class="white-space-nowrap m-0 font-16 font-bold"> Important Update: Action Required </span>
        </div>
    </ng-template>

    <div class="row">
        <div class="col-12">
            <p>Dear <strong> {{ clientChangeAgreementsDetails?.client_name }} </strong>,</p>
            <p>There’s been an update to Bell Bank’s Agreements. To continue using our services, you must review
                and
                acknowledge the updated terms for each of your accounts.</p>
            <p> <strong>Firm Name:</strong> {{ clientChangeAgreementsDetails?.firm_name }}</p>
            <strong>Your Accounts:</strong>
            <ul>
                @for (account of clientChangeAgreementsList; track $index) {
                  <li>🔗 {{ account?.account_number}} </li>
                }
            </ul>
            <p>In case of multiple accounts, each account requires a separate acknowledgment. Please review and accept
                the updated
                terms by clicking here to continue using our services.</p>
            <p>If you have any questions, please contact your advisor, <strong>{{
                    clientChangeAgreementsDetails?.advisor_name }}</strong>, at
                <strong>{{ clientChangeAgreementsDetails?.firm_name }}</strong>, or reach out to Bell Bank support.
            </p> <br>
            <p>📌 Thank you for your prompt attention to this update!</p>
        </div>
        <div class="col-12">
            <div class="submit-btn text-end mt-3 mb-2">
                <div class="flex justify-content-center mt-3">
                    <div class="flex justify-content-center gap-2">
                        <p-button label="Continue" (onClick)="goToBankDocument()" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</p-dialog>

<p-dialog [(visible)]="showResubmitApplications" [modal]="true" [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
    [style]="{ width: '50vw' }" [resizable]="false" [closable]="false" [draggable]="false">
    <ng-template pTemplate="header">
        <div class="flex-grow-1 flex align-items-center justify-content-start gap-2 custom-dialog">
            <span class="white-space-nowrap m-0 font-16 font-bold"> Action Required: Resubmit Your Application </span>
        </div>
        <div class="flex-grow-1 flex justify-content-end mr-2">
            <p-button icon="pi pi-times" [rounded]="true" text (onClick)="closeResubmitApplications()"></p-button>
        </div>
    </ng-template>

    <div class="row">
        <div class="col-12">
            <p class="mb-1">Hi <strong> {{ clientName }} </strong>,</p>
            <p>We’ve made the necessary updates to your application. Please review the updated details carefully, and once you're ready, click Continue to resubmit your application for verification.</p>
           
            <div class="custom-table my-3">
                <p-table [value]="resubmitApplications" appendTo="body" [paginator]="true" [rows]="15" [rowsPerPageOptions]="[5, 10, 15]"
                  styleClass="scrollable-custom-table help" [scrollable]="true">
                  <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th id="Product">Product</th>
                        <th id="Bank">Bank</th>
                        <th id="Action">Action</th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-liquidity let-columns="columns">
                    <tr>
                      <ng-container>
                        <td>
                            {{ liquidity?.ProductName }}
                          </td>
                          <td>
                            {{ liquidity?.InstitutionName }}
                          </td>
                          <td>
                            <p-button label="Continue" (onClick)="navigateToDetails(liquidity)" />
                          </td>
                      </ng-container>
                    </tr>
                  </ng-template>
                </p-table>
            </div>
        </div>
    </div>
</p-dialog>
